import { EditSingleMemberFirmCreationRequest } from '@bupa-kkv/features/company-creation/types';
import { companyCreationAxiosInstance } from '@bupa-monorepo/shared-frontend/admin/shared';

export const editSelfEmploymentCreations = (
  payload: EditSingleMemberFirmCreationRequest
): Promise<void> => {
  return companyCreationAxiosInstance.patch(
    'v1/customer/single-member-firm-creations/edit',
    payload
  );
};
